import { render, staticRenderFns } from "./guanZhu.vue?vue&type=template&id=2faffd94&scoped=true&"
import script from "./guanZhu.vue?vue&type=script&lang=js&"
export * from "./guanZhu.vue?vue&type=script&lang=js&"
import style0 from "./guanZhu.vue?vue&type=style&index=0&id=2faffd94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faffd94",
  null
  
)

export default component.exports